import React from 'react';
import NavigationTwo from '../Navigation/NavigationTwo';
import Banner from '../HomeTwo/Banner';
import FeaturesTwo from '../HomeTwo/FeaturesTwo';
import SeperatedBar from '../HomeTwo/SeperatedBar';
import About from '../HomeTwo/About';
import Contact from '../HomeTwo/Contact';
import Footer from '../Common/Footer';
 
class Home extends React.Component {
    render(){
        return (
            <>
                <NavigationTwo />

                {/* Main Banner */}
                <Banner />

                {/* Features Area */}
                <FeaturesTwo />

                {/* Vertical line */}
                <SeperatedBar />

                {/* About Area */}
                <About />

                {/* Vertical line */}
                <SeperatedBar />

                {/* Vertical line */}
                <SeperatedBar />

                {/* Contact Area */}
                <Contact />
                
                {/* Footer Area */}
                <Footer />
            </>
        );
    }
}
 
export default Home;